module.exports = __webpack_public_path__ + "static/img_7-bf49a8a6cd84a507cefb5b4661ba3346.png";